import { ZUZANA_CONTAINER_ID } from './chatbot-nudge';

function syncVisibility(): void {
  const el = document.getElementById(ZUZANA_CONTAINER_ID);
  if (!el) return;
  const hasDialog = !!document.querySelector('body > [role="dialog"]');
  const hasSearch = !!document.querySelector('body > .z-aa-panel');
  const hasMenu = !!document.querySelector('.hb-navigation.offcanvas--open');
  el.classList.toggle('hobbii-hidden', hasDialog || hasSearch || hasMenu);
}

export function initZuzanaVisibility(): void {
  new MutationObserver(syncVisibility).observe(document.body, {
    childList: true
  });
  const nav = document.querySelector('.hb-navigation');
  if (nav) {
    new MutationObserver(syncVisibility).observe(nav, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
}
